import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { PaginationSearchResponse, SearchRequest, ViewOrLinkedMeetingResponse } from 'src/app/models/search';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';
import { SearchService } from 'src/app/service/search.service';
import { UserService } from 'src/app/service/user.service';
import { environment, environment_const, environment_msg } from 'src/environments/environment';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PreviewMinutesDialogComponent } from '../preview-minutes-dialog/preview-minutes-dialog.component';
import { agendaList, MeetingResponse } from 'src/app/models/basicMeetingModel';
import { MatPaginator } from '@angular/material/paginator';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { MomService } from 'src/app/service/mom.service';
import { PermissionService } from 'src/app/service/permission.service';
import { ConfidentialDialogComponent } from '../confidential-dialog/confidential-dialog.component';
import {
  BreakpointObserver,
  Breakpoints,
  BreakpointState
} from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UtilityService } from 'src/app/service/utility.service';
@Component({
  selector: 'app-previous-meetings',
  templateUrl: './previous-meetings.component.html',
  styleUrls: ['./previous-meetings.component.css']
})
export class PreviousMeetingsComponent implements OnInit {

  toppings = new UntypedFormControl();
  toppingList: string[] = ['Agenda 1', 'Agenda 2', 'Agenda 3', 'Agenda 4', 'Agenda 5'];
  //today Meeting Date variable 
  todayMeeting: any
  //meeting end
  meetingEnded = false
  showCkEditorPanel = false
  fontStyleControl = new UntypedFormControl();
  noteChecker: any = true;
  taskChecker: any = true;
  decisionChecker: any = true;
  //UI changes
  dateChangeContent: any;
  minuteChangeContent: any;
  secondsChangeContent: any
  paneDirection = false;
  showPinDialogButtons = false;
  @Output() paneNumber = new EventEmitter<number>();
  fontStyle = 'Agenda';
  fontStyleContent = 'Agenda';
  options: any
  today: any
  currentDate: any
  defaultChecked = true
  currentTzName = this.globals.vShortTimeZone;
  startFilterDate: any;
  endFilterDate: any;
  isShown: boolean = false;
  calendar = new UntypedFormControl();
  //accordion opener variable
  sectionOpener: any
  participantExpansion = true;

  //instant meeting started variable
  meetingStarted = false;
  instantMeetingTriggeredFromDropDown = false

  //two pane
  rightPane = 0;
  leftPane = 100;
  checker: any;

  //pin div dialog
  pinDialogOpener = false
  pinDiv = false

  // mediaSub!: Subscription;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;


  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )

  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );

  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )

  //searchMeetingToLinkResp!:PaginationSearchResponse;
  searchMeetingToLinkReq: SearchRequest = new SearchRequest();
  searchResp!: ViewOrLinkedMeetingResponse[];
  linkedMeetingResp!: ViewOrLinkedMeetingResponse[];
  @ViewChild('searchPaginator') searchPaginator!: MatPaginator;
  @ViewChild('linkedPaginator') linkedPaginator!: MatPaginator;
  @ViewChildren('searchCkBox') private searchCkBoxList !: QueryList<any>;
  @ViewChildren('lnkedCkBox') private lnkedCkBoxList !: QueryList<any>;
  meetingResp: any;
  isSearchVisible: boolean = false;
  spinner: any = false;
  loggedInUser: any = this.globals.userId;
  @ViewChild('searchPreviousMeeting') searchPrevMeetTxt!: ElementRef;
  @Input() meetingRespFromComp!: MeetingResponse;
  dialogOpenChecker = false;
  showNoDataLinked!: boolean;
  showNoDataLink!: boolean;
  approvedMomStatus: String = environment.approvedMomStatus;
  disableCheckBox: boolean = false;
  flattenedDTOs?: agendaList[] = []; // Flattened array of DTOs

  readOnlyQuillConfig: any = {
    letter: false,
    modules: {
      toolbar: false
    },
    placeholder: ' ',
    theme: 'snow',
  };

  constructor(public util: UtilityService, private activatedRoute: ActivatedRoute, private router: Router, private readonly breakpointObserver: BreakpointObserver, private permissionService: PermissionService, public sideNav: SideNavServiceService, private dialog: MatDialog, private globals: Globals, private searchService: SearchService, private userService: UserService, private meetingService: MeetingService,
    @Optional() @Inject(MAT_DIALOG_DATA) data: { meetingResponse: any }, public momService: MomService, @Optional() private _mdr: MatDialogRef<PreviousMeetingsComponent>) {
    if (data != null) {
      this.meetingResp = data.meetingResponse;
    }
    this.dialogOpenChecker = sideNav.dialogCheckedEmitter()
 
  }

  ngOnChanges() {
    
    // let dateRangeFilter = <HTMLElement>document.getElementById('date-range-filter-up');
    // dateRangeFilter.hidden = true
  }


  redirectToMeeting(meeting: any) {
    var accessFlag = this.permissionService.checkUserRightsWithAlert(this.util.featureList.MEETINGS, this.util.permissionType.MODIFY);
    if (!accessFlag) {
      return;
    }


    if (meeting.isConfidential == "Y") {
      if (this._mdr != null) {
        this._mdr.close(false)
      }
      let dialogRef = this.dialog.open(ConfidentialDialogComponent, {
        panelClass: ['animate__animated', 'animate__slideInRight'],
        disableClose: true,
        position: {
          left: "50%"
        },
        maxWidth: "100%",
        maxHeight: "100vh",
        width: "50%",
        data: { isConfidentialCheck: true, meetingObj: meeting, flag: true, meetingStartFlag: "N", showMoM: true }
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }
    // else if(meeting.momStatus == 'A'){
    //   this.router.navigate(['approvedMeeting'], { queryParams: { "meetingResult": JSON.stringify( {"meetingId" : meeting.meetingId, "showMoM" : true })}, skipLocationChange: true, replaceUrl: false });
    // }
    else {
      if (this._mdr != null) {
        this._mdr.close(false)
      }
      this.router.navigate(['schedule'], { queryParams: { "meetingResult": JSON.stringify({ "meetingId": meeting.meetingId, "showMoM": true }) }, skipLocationChange: true, replaceUrl: false });
    }
  }



  toggleSelector(event: any) {
    let arrayValue = event.value;
    let notes = 'notes';
    let task = 'task';
    let decision = 'decision';
    let noteIcon = <HTMLElement>document.getElementById('notes-icon');
    let taskIcon = <HTMLElement>document.getElementById('task-icon');
    let decisionIcon = <HTMLElement>document.getElementById('decision-icon')
    if (arrayValue.includes(notes) == true) {
      this.noteChecker = true;
      noteIcon.setAttribute('style', 'color:white')
    }
    else {
      this.noteChecker = false;
      noteIcon.removeAttribute('style')
    }
    if (arrayValue.includes(task) == true) {
      this.taskChecker = true;
      taskIcon.setAttribute('style', 'color:white')
    }
    else {
      this.taskChecker = false;
      taskIcon.removeAttribute('style')
    }
    if (arrayValue.includes(decision) == true) {
      this.decisionChecker = true;
      decisionIcon.setAttribute('style', 'color:white')
    }
    else {
      this.decisionChecker = false;
      decisionIcon.removeAttribute('style')
    }
 
  }

  toggleAgendaAndMom(event: any, id: any) {
    let momSection = <HTMLElement>document.getElementById('momSection' + id);
    let agendaSection = <HTMLElement>document.getElementById('agendaSection' + id);
    if (event.value == 'Agenda') {
      momSection.setAttribute('style', 'display:none')
      agendaSection.removeAttribute('style')
    }
    if (event.value == 'MOM') {
      momSection.removeAttribute('style')
      agendaSection.setAttribute('style', 'display:none')
    }
  }

  linkMeetingToggleAgendaAndMom(event: any, id: any) {
    let linkMomSection = <HTMLElement>document.getElementById('linkMomSection' + id);
    let linkAgendaSection = <HTMLElement>document.getElementById('linkAgendaSection' + id);
    if (event.value == 'Agenda') {
      linkMomSection.setAttribute('style', 'display:none')
      linkAgendaSection.removeAttribute('style')
    }
    if (event.value == 'MOM') {
      linkMomSection.removeAttribute('style')
      linkAgendaSection.setAttribute('style', 'display:none')
    }
  }

  linkedMeetingToggleAgendaAndMom(event: any, id: any) {
    let linkMomSection = <HTMLElement>document.getElementById('momSection' + id);
    let linkAgendaSection = <HTMLElement>document.getElementById('agendaSection' + id);
    if (event.value == 'Agenda') {
      linkMomSection.setAttribute('style', 'display:none')
      linkAgendaSection.removeAttribute('style')
    }
    if (event.value == 'MOM') {
      linkMomSection.removeAttribute('style')
      linkAgendaSection.setAttribute('style', 'display:none')
    }
  }


  //pin dialog function

  pinDialog(bool: any) {
    this.pinDiv = bool;
    // window.alert("trigger")
    if (this.pinDiv == true) {
      this.showPinDialogButtons = true
      let pindDialog = document.getElementsByClassName('rogowclass')
 
      pindDialog[0].setAttribute('style', 'height : calc(100vh - 100px);width : 48%;margin-top:62px;margin-left:52%')
      // style.height = '85vh';
      // pindDialog.style.width = '50%';
      // pindDialog.style.marginTop = '62px';
      // pindDialog.style.marginLeft = '52%';
      // let pindDialog9 = <HTMLElement>document.getElementById('mat-dialog-0');
      // pindDialog9.style.boxShadow = 'none';
      let cdkoverlaybackdrop = document.getElementsByClassName('cdk-overlay-backdrop');
      let linkMeetingWrapper = <HTMLElement>document.getElementById('link-meeting-wrapper');
      linkMeetingWrapper.style.boxShadow = 'none';
 
      cdkoverlaybackdrop[0].setAttribute('style', 'display : none')
      let exampleSidenavContent = document.getElementsByClassName('example-sidenav-content');
      exampleSidenavContent[0].setAttribute('style', 'width : 50%')
      let headerFixedContentContainer = document.getElementsByClassName('header-fixed-content-container');
      headerFixedContentContainer[0].setAttribute('style', 'height:calc(100vh - 243px)')
      // notesWrapper.style.marginRight = '25px';
      // taskWrapper.style.marginRight = '25px';
      // decisionWrapper.style.marginRight = '25px';
      // this.pinDiv = !this.pinDiv
      // // this.pinDiv = true
      // if(this.pinDiv == true){   
      //   // this.sideNav.BackDropEnabler(false)   
      //   this.rightPane = 50
      //   this.leftPane = 50
      // }
      // else{
      //   this.leftPane = 100
      //   this.rightPane = 0
      //   // this.sideNav.BackDropEnabler(true)
      // }
    }
    if (this.pinDiv == false) {
      this.showPinDialogButtons = false
      let pindDialog = document.getElementsByClassName('rogowclass')
 
      pindDialog[0].setAttribute('style', 'max-width: 100%;max-height: 100vh;width: 50%;height: 100vh;position: static;margin-top: 0px;margin-left: 50%;')
      // style.height = '85vh';
      // pindDialog.style.width = '50%';
      // pindDialog.style.marginTop = '62px';
      // pindDialog.style.marginLeft = '52%';
      // let pindDialog9 = <HTMLElement>document.getElementById('mat-dialog-0');
      // pindDialog9.style.boxShadow = 'none';
      let cdkoverlaybackdrop = document.getElementsByClassName('cdk-overlay-backdrop');
      let linkMeetingWrapper = <HTMLElement>document.getElementById('link-meeting-wrapper');
      linkMeetingWrapper.style.boxShadow = 'none';
 
      cdkoverlaybackdrop[0].setAttribute('style', 'display : block')
      let exampleSidenavContent = document.getElementsByClassName('example-sidenav-content');
      exampleSidenavContent[0].setAttribute('style', 'width : 100%')

      let headerFixedContentContainer = document.getElementsByClassName('header-fixed-content-container');
      headerFixedContentContainer[0].removeAttribute('style')
      // this.pinDiv = !this.pinDiv
      // // this.pinDiv = true
      // if(this.pinDiv == true){   
      //   // this.sideNav.BackDropEnabler(false)   
      //   this.rightPane = 50
      //   this.leftPane = 50
      // }
      // else{
      //   this.leftPane = 100
      //   this.rightPane = 0
      //   // this.sideNav.BackDropEnabler(true)
      // }
    }
  }

  //pin dialog opener function

  opePinDialog($event: any) {
    this.pinDialogOpener = !this.pinDialogOpener;
    ////consolee.log("pinDialogOpener",this.pinDialogOpener)
  }

  closeRightPinOpener() {
    this.paneNumber?.emit(0);
    // let pindDialog = document.getElementsByClassName('rogowclass')
    
    // pindDialog[0].removeAttribute('style')
    // this.rightPane = 0;
    // // style.height = '85vh';
    // // pindDialog.style.width = '50%';
    // // pindDialog.style.marginTop = '62px';
    // // pindDialog.style.marginLeft = '52%';
    // // let pindDialog9 = <HTMLElement>document.getElementById('mat-dialog-0');
    // // pindDialog9.style.boxShadow = 'none';
    // let cdkoverlaybackdrop = document.getElementsByClassName('cdk-overlay-backdrop');
    // let linkMeetingWrapper = <HTMLElement>document.getElementById('link-meeting-wrapper');
    // linkMeetingWrapper.removeAttribute('style')
    
    // cdkoverlaybackdrop[0].removeAttribute('style')
    // let exampleSidenavContent = document.getElementsByClassName('example-sidenav-content');
    // exampleSidenavContent[0].removeAttribute('style')
    // let headerFixedContentContainer = document.getElementsByClassName('header-fixed-content-container');
    // headerFixedContentContainer[0].removeAttribute('style')
    // // this.pinDialogOpener = false
    // // // this.sideNav.BackDropEnabler(false)
    // // this.leftPane = 100;
    // // this.rightPane = 0
  }

  previewMinutesDialog(id: any) {
    let iframeContainer = <HTMLElement>document.getElementById('iframe-container' + id);
 
    if (iframeContainer.style.display == 'none') {
      iframeContainer.removeAttribute('style')
    }
    else {
      iframeContainer.setAttribute('style', 'display:none')
    }

  }

  dateContentChanger(value: any) {
    this.dateChangeContent = value
    ////consolee.log("Value from date change",value)
  }

  ngOnInit(): void {
 
    this.options = {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }

    // if(this.sideNav.openInstantMeetingTransmitter() == false){
    //   document.getElementById('edit-icon')?.click()
    //   let editIcon = (<HTMLElement>document.getElementById('edit-icon'))
    //   // editIcon.hidden = true
    //   editIcon.style.display = "none"
    // }
    // if(this.showMomVariable){
    //   let editIcon = (<HTMLElement>document.getElementById('edit-icon'))
    //         editIcon.style.display = "block";
    //         editIcon.click()
    // }

    // this.mediaSub = this.mediaObserver.media$.subscribe((result: MediaChange) => {
    //   ////consolee.log(result.mqAlias)
    //   this.deviceXs = result.mqAlias === 'xs' ? true : false
    //   this.deviceSm = result.mqAlias === 'sm' ? true : false
    //   this.deviceMd = result.mqAlias === 'md' ? true : false
    //   this.deviceLg = result.mqAlias === 'lg' ? true : false
    //   this.deviceXl = result.mqAlias === 'xl' ? true : false
    // })

    this.today = new Date();
    this.currentDate = this.today.toLocaleDateString("en-US", this.options)
    if ((this.meetingResp == null || this.meetingResp == undefined) && this.meetingRespFromComp != null) {
      this.meetingResp = this.meetingRespFromComp;
      
    }
    setTimeout(() => { this.fetchLinkedMeetingUrl() }, 5);
    if (this.meetingResp.commonMomStatusCode != undefined && this.meetingResp.commonMomStatusCode == environment_const.momApproveStatus) {
      this.disableCheckBox = true;
    }
  }

  viewLinkTab(tab: MatTabChangeEvent) {
    let matTabHeader = document.getElementsByClassName('mat-tab-header');
    let matTabBodyWrapper = document.getElementsByClassName('mat-tab-body-wrapper');
    let closeBtn = <HTMLElement>document.getElementById('close-btn');
    // let linkTabContainer = document.getElementById('link-tab-container');
    // let linkedTabContainer = document.getElementById('linked-tab-container');
 
    // setTimeout(() => {      
    //   matTabHeader[0].setAttribute('style','margin-top : 0px!important')
    //   matTabBodyWrapper[0].setAttribute('style','height : calc(100vh - 150px)!important; overflow : hidden!important')
    //   
    //   
    //   // linkTabContainer?.setAttribute('style','height: calc(100vh - 194px);width: 100%;overflow-y: auto;');
    //   // linkedTabContainer?.setAttribute('style','height: calc(100vh - 194px);width: 100%;overflow-y: auto;');
    // },700)
    if (tab.index === 1) {
      this.isSearchVisible = true;
      if (this.searchResp == null) {
        this.fetchMeetingToLink();
      }
      // matTabHeader[0].removeAttribute('style')
      // matTabBodyWrapper[0].removeAttribute('style')
      // setTimeout(() => {
      
      
      //   matTabHeader[0].setAttribute('style','margin-top : 0px!important')
      //   matTabBodyWrapper[0].setAttribute('style','height : calc(100vh - 215px)!important; overflow-y : auto!important')
      // },700)

    } else {
      this.isSearchVisible = false;
      //if(this.linkedMeetingResp==null){
      this.fetchLinkedMeetingUrl();
      //}
      // setTimeout(() => {
      
      
      //   matTabHeader[0].setAttribute('style','margin-top : 0px!important')
      //   matTabBodyWrapper[0].setAttribute('style','height : calc(100vh - 215px)!important; overflow-y : auto!important')
      // },700)
    }
  }

  fetchMeetingToLink() {
    var searchText = this.searchPrevMeetTxt.nativeElement.value;
    if (searchText != null && searchText != "") {
      this.searchMeetingToLinkReq.searchText = searchText;
      this.searchMeetingToLinkReq.userId = this.globals.userId;
      this.searchMeetingToLinkReq.visitorTimezone = this.globals.vTimeZone;
      this.searchMeetingToLinkReq.searchType = environment_const.TO_LINK_MEETING;
      this.searchMeetingToLinkReq.reportedUsersId = this.globals.userId + "," + this.globals.repotingUsers;
      this.searchMeetingToLinkReq.meetingIdList = this.getLinkedIdList();
      this.searchMeetingToLinkReq.pageStart = this.getPageStart(this.searchPaginator);//this.searchPaginator.pageIndex==0?0:(this.searchPaginator.pageIndex+this.searchPaginator.pageSize);
      this.searchMeetingToLinkReq.pageEnd = this.getPageEnd(this.searchPaginator);//(this.searchPaginator.pageIndex+1)*this.searchPaginator.pageSize;
      //this.searchMeetingToLinkReq.startDate="2022-03-31T18:30:00.000Z";
      //this.searchMeetingToLinkReq.endDate="2022-04-07T18:30:00.000Z";
      this.spinner = true;
      this.searchService.toLinkMeetingSearch(this.searchMeetingToLinkReq).subscribe((resp: any) => {
        //alert("search data"+resp.body);
        if (resp.body != null && resp.body.totalCount != null && resp.body.totalCount != 0) {
          this.searchResp = resp.body.dataList;
          this.searchPaginator.length = resp.body.totalCount;
          this.showNoDataLink = false;
        } else {
          this.searchResp = [];
          this.searchPaginator.length = 0;
          this.showNoDataLink = true;
        }
      }).add(() => {
        this.spinner = false;
      });
    } else {
      this.searchResp = [];
    }
    setTimeout(() => {
      this.searchPrevMeetTxt.nativeElement.focus()
    })
  }

getPageStart(paginator: MatPaginator) {
  return paginator.pageIndex * paginator.pageSize;
}

getPageEnd(paginator: MatPaginator) {
  return (paginator.pageIndex + 1) * paginator.pageSize;
}
  getLinkedIdList() {
    var meetingIdList: any = [];
    if (this.meetingResp.linkedMeetingInfo != null) {
      this.meetingResp.linkedMeetingInfo.forEach((element: any) => {
        meetingIdList.push(element.meetingId);
      });
    }
    meetingIdList.push(this.meetingResp.meetingId);
    return meetingIdList;
  }

  saveLinkMeeting(linkIds: any) {
    var meetingIdList: any = [];
    meetingIdList.push(linkIds);
    var req = {
      "userId": this.globals.userId,
      "visitorTimeZone": this.globals.vTimeZone,
      "meetingId": this.meetingResp.meetingId,
      "meetingIdList": meetingIdList,
      "meetingLinkType": environment_const.linkTypeCode
    }
    this.spinner = true;
    this.meetingService.saveMeetingToLink(req).subscribe((resp: any) => {
      if (resp.body != null) {
        this.meetingResp.linkedMeetingInfo = resp.body.linkedMeetingInfo;
      }
      this.fetchMeetingToLink();
    }).add(() => {
      this.spinner = false;
    });
  }

  confirmMeetingToLink(linkIds: any, event: any, index: any) {
    if (event.checked) {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          dialogTitle: "Confirmation",
          dialogContent: environment_msg.msg_confirm_link_meeting
        },
      }).afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.saveLinkMeeting(linkIds);
          return true;
        } else {
          //(<HTMLInputElement>event.target).checked=true;
          //event.preventDefault();

          //   let index = event.source.value[1];
          let checkboxesArray = this.searchCkBoxList.toArray();
          checkboxesArray[index].checked = false;
          return false;
        }
      });
    }
  }


  confirmMeetingToUnLink(linkIds: any, event: any, index: any) {
    if (!event.checked) {
      this.dialog.open(ConfirmDialogComponent, {
        data: {
          dialogTitle: "Confirmation",
          dialogContent: environment_msg.msg_confirm_unlink_meeting
        },
      }).afterClosed().subscribe((confirmed: boolean) => {
        if (confirmed) {
          this.unLinkMeeting(linkIds);
          return true;
        } else {
          let checkboxesArray = this.lnkedCkBoxList.toArray();
          checkboxesArray[index].checked = true;
          return false;
        }
      });
    }
  }


  unLinkMeeting(unLinkId: any) {
 
    var meetingIdList: any = [];
    meetingIdList.push(unLinkId);
 
    var req = {
      "userId": this.globals.userId,
      "visitorTimeZone": this.globals.vTimeZone,
      "meetingId": this.meetingResp.meetingId,
      "meetingIdList": meetingIdList,
      "meetingLinkType": environment_const.linkTypeCode
    }
    this.spinner = true;
    this.meetingService.saveMeetingToUnlink(req).subscribe((resp: any) => {
 
      if (resp.body != null && resp.body.linkedMeetingInfo != null) {
        this.meetingResp.linkedMeetingInfo = resp.body.linkedMeetingInfo;
      }
 
      this.fetchLinkedMeetingUrl();
    }).add(() => {
      this.spinner = false;
    });
  }
  triggerRefresh() {

  }
  triggerAlert() {
 
 
    this.isShown = true;
  }
  toggleFilter(filterName: any) {
    let dateRangeFilter = <HTMLElement>document.getElementById('date-range-filter-up');
    let searchFilter = <HTMLElement>document.getElementById('search-filter-up');
    //this.paginator.pageIndex=0;
    switch (filterName) {
      case "search":
        dateRangeFilter != null ? dateRangeFilter.hidden = true : '';
        searchFilter.hidden = false;
        break;

      case "dateRange":
        window.alert("called")
        // this.triggerRefresh()
        this.isShown = true;
   
        // document.getElementById('calendar-click-icon')?.click()
        dateRangeFilter?.removeAttribute('hidden')
        this.startFilterDate = "";
        this.endFilterDate = "";
        // dateRangeFilter.hidden = false;
        // searchFilter.hidden = true;
        break;
    }
  }
  fetchLinkedMeetingUrl() {
    var req = {
      "meetingId": this.meetingResp.meetingId,
      "visitorTimeZone": this.globals.vTimeZone,
      //  "startDate":"2022-03-31T18:30:00.000Z",
      //  "endDate":"2022-04-07T18:30:00.000Z",
      "pagination": {
        "idisplayLength": this.linkedPaginator.pageSize,
        "idisplayStart": this.linkedPaginator.pageIndex//this.getPageStart(this.linkedPaginator)
      }
    }
    this.spinner = true;
    this.meetingService.getLinkedMeeting(req).subscribe((resp: any) => {
      this.linkedMeetingResp = resp.body.dataList;
      this.linkedPaginator.length = resp.body.totalCount;
      if (resp.body != null && resp.body.totalCount != null && resp.body.totalCount != 0) {
        this.linkedMeetingResp = resp.body.dataList;
        this.linkedPaginator.length = resp.body.totalCount;
        this.showNoDataLinked = false;
      } else {
        this.linkedMeetingResp = [];
        this.linkedPaginator.length = 0;
        this.showNoDataLinked = true;
      }
 
    }).add(() => {
      this.spinner = false;
    });
  }

  fetchAgendaListFromSearch(meetingId: any, index: any) {
    if (this.searchResp[index].agendaList == null) {
      this.spinner = true;
      this.meetingService.fetchAgendaListByMeetingId(meetingId).subscribe((dataObj: any) => {
        this.searchResp[index].agendaList = dataObj.body;
      }).add(() => {
        this.spinner = false;
      });
    }
  }

  fetchAgendaListForLinkedMeeting(meetingId: any, index: any) {
    if (this.linkedMeetingResp[index].agendaList == null) {
      this.spinner = true;
      this.meetingService.fetchAgendaWithSubListByMeetingId(meetingId).subscribe((dataObj: any) => {
        this.flattenedDTOs = dataObj.body;
        this.rebuildHierarchy(index);
      }).add(() => {
        this.spinner = false;
      });
    }
  }
  //method to show mom tab info for search
  loadMomListForSearch(meetingId: any, index: any) {
    if (this.searchResp[index].momList == null) {
      this.spinner = true;
      this.momService.fetchMomList(meetingId).subscribe((resp: any) => {
        this.searchResp[index].momList = resp.body;
      }, () => { // when complete
        // alert("inside");

      }).add(() => {
        this.spinner = false;
      });
    }
  }
  //method to show mom tab info for linked meeting
  loadMomListForLinkedMeeting(meetingId: any, index: any) {
    if (this.linkedMeetingResp[index].momList == null) {
      this.spinner = true;
      this.momService.fetchMomList(meetingId).subscribe((resp: any) => {
        this.linkedMeetingResp[index].momList = resp.body;
      }, () => { // when complete
      }).add(() => {
        this.spinner = false;
      });
    }
  }

  loadApprovedPdf(momList: any) {
    if (momList != null && momList.momStatusCode == this.approvedMomStatus) {
      this.spinner = true;
      var reqJson = {
        "pkMomDetailId": momList.pkMomDetailId,
        "fkMeetingEntityId": momList.fkMeetingEntityId,
        "userId": this.globals.userId,
        "momStatus": momList.momStatusCode
      }
      this.momService.fetchApprovedPdf(reqJson).subscribe((resp: any) => {
        let file = new Blob([resp], { type: 'application/pdf' });
        var blobUrl = URL.createObjectURL(file);
        var pdfFrame = <HTMLElement>document.getElementById('pdfFrame' + momList.pkMomDetailId);
        pdfFrame.setAttribute("src", blobUrl);
      }).add(() => {
        this.spinner = false;
      });
    }
  }
  //method to show attendee name from search
  splitAttendeeName(nameList: any) {
    return nameList!.split(",");
  }
  //method to show participant count in search
  getParticipantCount(nameList: any) {
    return nameList!.split(",").length;
  }
rebuildHierarchy(index : any) {
 
      // Initialize a map to store DTOs by id for quick lookup
      const dtoMap: { [id: number]: agendaList } = {};
      if(this.flattenedDTOs!=undefined){
      for (let j = 0; j < this.flattenedDTOs.length; j++) {
        let numIndex:number=+this.flattenedDTOs[j].agendaId;
        dtoMap[numIndex] = this.flattenedDTOs[j];
  
      }
      this.linkedMeetingResp[index].agendaList = this.flattenedDTOs?.filter(dto => !dto.parentAgendaId)
  
                                          .map(rootDto => this.buildTree(rootDto, dtoMap));
                                     
    }
 
 
    }
 
    buildTree(dto: agendaList, dtoMap: { [agendaId: number]: agendaList }): agendaList {
        const children = this.flattenedDTOs?.filter(child => child.parentAgendaId === dto.agendaId);
        
        if (children!=undefined && children.length > 0) {
          dto.subtopics = children.map(child => this.buildTree(child, dtoMap));
        }else{
          dto.subtopics=[];
        }
        return dto;
      }
}
